<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.logisticsRelated') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.deadlineForDay') }}</label>
          <div class="value">{{ detail.cutOffTime || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.confirmTimeFromMerchant') }}</label>
          <div class="value">
            {{ detail.latestConfirmTime || '-' }}
          </div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.shippingDeadline') }}</label>
          <div class="value">
            {{ detail.latestDeliveryTime || '-' }}
          </div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.orderShippingDay') }}</label>
          <div class="value">{{ detail.deliveryTime || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.tmsLogisticsRoute') }}</label>
          <div class="value">{{ detail.logisticsRoute || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.logisticsType') }}</label>
          <div class="value">{{ detail.logisticsType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.expressConfig') }}</label>
          <div class="value">{{ detail.expressConfig || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.logisticsSettlementMethod') }}</label>
          <div class="value">{{ detail.logisticsSettlementType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.transferWarehouseName') }}</label>
          <div class="value">{{ detail.transferWarehouseName || '-' }}</div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('common.stockLocation') }}</h2>
      <div class="info-group">
        <div class="info-item full" v-for="item in list" :key="item.locationId">
          <label>{{ $t('crm.stockLocationId') }}: {{ item.locationId }}</label>
          <div class="value">
            <p>{{ $t('common.status') }}: {{ item.state }}</p>
            <p>{{ $t('crm.stockLocationName') }}: {{ item.stockLocation }}</p>
            <p>{{ $t('crm.shipFromStockLocation') }}: {{ item.shipFromStockLocation }}</p>
            <p>{{ $t('crm.companyName') }}: {{ item.contactCompanyName }}</p>
            <p>{{ $t('crm.contactPerson') }}: {{ item.contactPersonName }}</p>
            <p>{{ $t('crm.contactEmail') }}: {{ item.contactEmailAddress }}</p>
            <p>{{ $t('crm.contactPhoneNumber') }}: {{ item.contactPhoneNumber }}</p>
            <p>{{ $t('common.country') }}: {{ item.addressCountryCode }}</p>
            <p>{{ $t('common.city') }}: {{ item.addressCity }}</p>
            <p>{{ $t('common.postCode') }}: {{ item.addressPostalCode }}</p>
            <p>{{ $t('common.address') }}: {{ item.addressStreetLinesAll }}</p>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStockLocationByVendorId, getLogisticsInfo } from '../api';

export default {
  data() {
    return {
      list: [],
      detail: {},
    };
  },
  mounted() {
    getStockLocationByVendorId({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.list = res.data.data;
      }
    });
    getLogisticsInfo({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        res.data.data.deliveryTime = this.formatDeliveryTime(res.data.data.deliveryTime);
        this.detail = res.data.data;
      }
    });
  },
  methods: {
    formatDeliveryTime(deliveryTime) {
      if (deliveryTime && deliveryTime.length > 0) {
        return deliveryTime.sort().map(item => this.$t(`common.week${item - 1}`)).join(', ');
      } else {
        return '-';
      }
    },
  },
}
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n+3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }

  &.full {
    width: 100%;

    &:nth-child(even) {
      label {
        border-left: 1px solid #EBEEF5;
      }
    }
    &:nth-child(n+3) {
      label {
        border-top: 0;
      }
      .value {
        border-top: 0;
      }
    }
  }
}
</style>